import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { ViewCarousel, Visibility } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Detail from "./Modals/Detail";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";
import { format } from "date-fns";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailModel: false,
      selectedId: null,
    };
  }

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDetailAction = (row) => {
    this.setState({
      selectedId: row[0],
      detailModel: true,
    });
  };

  handleCustomDatum = (item) => {
    return format(new Date(item.ts * 1000), "dd-MM-yyyy HH:mm:ss");
  };

  render() {
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Apilog"} tKey={"apilog.pagetitle"} />} />

        <GridContainer>
          <VestigingenFilter />
          <GridItem md={2} xs={12}>
            <TextFilter
              field={"bestelling_id"}
              fieldKey={"apilog:bestelling_id"}
              operator={"="}
              placeholder={getTranslation("bestellingen.filter.orderid", "Bestel nummer")}
            />
          </GridItem>
          <GridItem md={2} xs={12}>
            <TextFilter
              field={"api"}
              fieldKey={"apilog:api"}
              operator={"like"}
              placeholder={getTranslation("bestellingen.filter.api", "Api")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Visibility,
                  tooltip: <TranslationWrapper tDefault={"Show details"} tKey={"apilog.table.tooltip.showDetails"} />,
                  action: this.handleDetailAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "bestelling_id", editable: false },
                { customData: this.handleCustomDatum },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { dbfield: "tafel.naam", editable: false },
                { dbfield: "call", editable: false },
                { dbfield: "resultmsg", editable: false },
                { dbfield: "result", editable: false },
                { dbfield: "api", editable: false },
              ]}
              dbfields={
                "id,bestelling_id,ts,vestiging_id,vestiging.id,vestiging.systeemNaam,tafel_id,tafel.id,tafel.naam,call,resultmsg,result,api"
              }
              fetchUrl={"core/apilog"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("apilog.table.id", "#Api"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("apilog.table.bestelling_id", "#Order"),
                  sortable: true,
                  sortKey: "bestelling_id",
                },
                {
                  label: getTranslation("apilog.table.datum", "Datum"),
                  sortable: true,
                  sortKey: "ts",
                },
                {
                  label: getTranslation("apilog.table.vestiging", "Vestiging"),
                  sortable: true,
                  sortKey: "vestiging.systeemNaam",
                },
                {
                  label: getTranslation("apilog.table.tafel", "Tafel"),
                  width: "15%",
                  sortable: true,
                  sortKey: "tafel.naam",
                },
                {
                  label: getTranslation("apilog.table.call", "Call"),
                  width: "25%",
                  sortable: false,
                },
                {
                  label: getTranslation("apilog.table.result", "Result"),
                  width: "5%",
                  sortable: false,
                },
                {
                  label: getTranslation("apilog.table.status", "Status"),
                  width: "5%",
                  sortable: false,
                },
                { label: getTranslation("apilog.table.api", "API"), sortable: false },
              ]}
              reduxKey={"apilog"}
              showAutoRenew
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Apilog"} tKey={"apilog.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        <Detail
          apilogId={this.state.selectedId}
          open={this.state.detailModel}
          toggle={() => this.toggleModal("detailModel")}
        />
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["apilog:bestelling_id"]) {
    filters["apilog:bestelling_id"] = state.filtersV2["apilog:bestelling_id"];
  }
  if (state.filtersV2["apilog:api"]) {
    filters["apilog:api"] = state.filtersV2["apilog:api"];
  }
  return {
    filters,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
